var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9354 0.347656C11.9319 0.396233 8.10601 2.00821 5.27488 4.83934C2.44376 7.67046 0.83178 11.4963 0.783203 15.4998C0.83178 19.5033 2.44376 23.3292 5.27488 26.1603C8.10601 28.9914 11.9319 30.6034 15.9354 30.652C19.9389 30.6034 23.7647 28.9914 26.5959 26.1603C29.427 23.3292 31.039 19.5033 31.0876 15.4998C31.039 11.4963 29.427 7.67046 26.5959 4.83934C23.7647 2.00821 19.9389 0.396233 15.9354 0.347656ZM24.5938 16.5821H17.0177V24.1582H14.8531V16.5821H7.27699V14.4175H14.8531V6.84144H17.0177V14.4175H24.5938V16.5821Z",
    fill: "#0A3575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.496410954315a6ff78270b78c0324b12.svg";
export { ForwardRef as ReactComponent };